import React from 'react';
import { SortingModelExample } from '../../Components/SortingModel';
import styled from 'styled-components';

const TestPageContainer = styled.div`
  min-height: 100vh;
  background: #f5f5f5;
  padding: 20px;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

const PageTitle = styled.h1`
  color: #333;
  margin-bottom: 10px;
`;

const PageDescription = styled.p`
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
`;

const SortingModelTest = () => {
  return (
    <TestPageContainer>
      <PageHeader>
        <PageTitle>Sorting Model Test Page</PageTitle>
        <PageDescription>
          This page demonstrates the Redux-integrated sorting model functionality. 
          You can create custom hospital rankings by adjusting weightages for different KPIs 
          and see the results in real-time.
        </PageDescription>
      </PageHeader>
      
      <SortingModelExample />
    </TestPageContainer>
  );
};

export default SortingModelTest;
